module.exports = __webpack_public_path__ + "static/melon-12720c7d8d995d7f2cfbe79974bd7c19.svg";